import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import WorkTypeUpdate from './form/work-type-update';
import WorkType from './view/work-type';

const WorkTypeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<WorkType />} />
    <Route path="new" index element={<WorkTypeUpdate />} />
    <Route path=":id">
      <Route index element={<WorkTypeUpdate />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default WorkTypeRoutes;
